export default __webpack_public_path__ + "media/zurb/fonts/Heroes Legend-7f2a0db9ef69f83f512866a40c51c5e2.ttf";